
import store from '@/store';

// Null-sicher (L1): Zwischen dispatch('signOut') und dem Routenwechsel ist profile null; dann gibt es keine Rechte.
// Bei vorhandenem Profil identisch zu vorher.
export const hasPermission = (permissionName) => {
  const profile = store.state.profile;
  return !!profile && Array.isArray(profile.permissions) && profile.permissions.some(permission => permission.name === permissionName);
};

// Rolle ADMIN (bisher dreimal in MainLayout: Shop, Schnittstellen, Kundeneinstellungen), null-sicher
export const isAdmin = () => !!store.state.profile && store.state.profile.role === 'ADMIN';

